import { projectsApi } from 'api'

export interface PersistentPlatformFile {
  id: string
  name: string
  originalName: string
  description: string
  created: string
  modified: string
  downloadUrl: string
  webUrl: string
  size: number
  mimeType: string
  metaData: any
}

export const fetchFileById = ({ fileId }: { fileId: string }) =>
  projectsApi.get<PersistentPlatformFile>(`/files/${fileId}`)
